<template>
    <div>
        <draggable
            v-if="medicalNoteContent.length"
            :list="medicalNoteContent"
            tag="div"
            ghost-class="sort-row-ghost"
            drag-class="sort-row-drag"
            :animation="0"
            handle=".handle"
            @sort="itemsSorted()"
        >
            <!-- Parent Part -->
            <div
                v-for="parent in medicalNoteContent"
                :key="parent.id"
                class="form_template_category"
            >
                <div class="d-flex input_label handle">
                    <div class="d-flex align-items-center">
                        <i class="cursor-move cus-black-white-swatch" />
                    </div>
                    <span class="parent_label">{{ parent.label }}</span>
                </div>

                <!-- Children Part -->
                <div>
                    <draggable
                        v-if="parent.data"
                        :list="parent.data"
                        tag="div"
                        ghost-class="sort-row-ghost"
                        drag-class="sort-row-drag"
                        :animation="0"
                        handle=".handleChildren"
                        @sort="itemsSorted(parent.id)"
                    >
                        <div
                            v-for="children in parent.data"
                            :key="children.id"
                            class="form_template_component"
                        >
                            <div class="row mx-0 pb-1">
                                <div
                                    class="px-0 handleChildren"
                                    :class="
                                        children.data.length > 0
                                            ? 'col-12'
                                            : 'col-2'
                                    "
                                >
                                    <div class="input_label">
                                        <i
                                            :class="
                                                children.id !==
                                                'fm_soap_diagnoses'
                                                    ? 'cursor-move cus-black-white-swatch'
                                                    : null
                                            "
                                            class="marginTopHandle"
                                        ></i>
                                        <span
                                            :class="{
                                                'font-weight-bold':
                                                    children.id ===
                                                    'fm_soap_diagnoses'
                                            }"
                                            >{{ children.label }}</span
                                        >
                                    </div>
                                </div>

                                <!-- 
                                If children.data is empty (last section), 
                                then show required input field/dropdown/single select/multi select/textarea 
                                -->
                                <template v-if="children.data.length == 0">
                                    <div
                                        v-if="
                                            getFieldType(children) ===
                                            'textarea'
                                        "
                                        class="col-10 pr-0"
                                    >
                                        <textarea
                                            class="form-control mb-1"
                                            :name="children.id"
                                            v-model="children.comment"
                                        ></textarea>
                                    </div>

                                    <div
                                        v-else-if="
                                            getFieldType(children) === 'input'
                                        "
                                        class="col-10 pr-0"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            :name="children.id"
                                            v-model="children.comment"
                                        />
                                    </div>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'value_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <input
                                                :type="
                                                    children.options.isNumber
                                                        ? 'number'
                                                        : 'text'
                                                "
                                                placeholder="Value"
                                                class="form-control"
                                                :name="`${children.valueId}`"
                                                v-model="children.value"
                                                v-validate-numeric-on-blur="
                                                    children.options.isNumber
                                                "
                                            />
                                        </div>

                                        <div class="col-8 pr-0">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'dropwdown_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <select
                                                :name="children.id"
                                                :id="children.id"
                                                v-model="children.value"
                                                class="form-control"
                                            >
                                                <option
                                                    v-for="option in getDropdownSelectedOptions(
                                                        children
                                                    )"
                                                    :key="option.value"
                                                    :value="option.value"
                                                >
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="col-8 pr-0">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'value_dropdown_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <input
                                                :type="
                                                    children.options.isNumber
                                                        ? 'number'
                                                        : 'text'
                                                "
                                                class="form-control"
                                                :name="children.valueId"
                                                v-model="children.value"
                                                v-validate-numeric-on-blur="
                                                    children.options.isNumber
                                                "
                                                placeholder="Value"
                                            />
                                        </div>

                                        <div class="col-2 pr-0 d-flex">
                                            <select
                                                v-if="
                                                    children.options.options &&
                                                    Object.keys(
                                                        children.options.options
                                                    ).length > 1
                                                "
                                                :name="children.id"
                                                :id="children.id"
                                                v-model="children.value_type"
                                                class="form-control"
                                            >
                                                <option
                                                    v-for="option in getDropdownSelectedOptions(
                                                        children,
                                                        'value_type'
                                                    )"
                                                    :key="option.value"
                                                    :value="option.value"
                                                >
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                            <span
                                                v-else
                                                type="text"
                                                :name="children.id"
                                                >{{
                                                    getSingleOptionLabel(
                                                        children.options
                                                            .options,
                                                        children.value_type
                                                    )
                                                }}</span
                                            >
                                        </div>

                                        <div class="col-6 pr-0">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'value_dropdown_dropdown_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <input
                                                :type="
                                                    children.options.isNumber
                                                        ? 'number'
                                                        : 'text'
                                                "
                                                class="form-control"
                                                :name="children.valueId"
                                                v-model="children.value"
                                                placeholder="Value"
                                                v-validate-numeric-on-blur="
                                                    children.options.isNumber
                                                "
                                            />
                                        </div>

                                        <div class="col-2 pr-0 d-flex">
                                            <select
                                                v-if="
                                                    children.options.options &&
                                                    Object.keys(
                                                        children.options.options
                                                    ).length > 1
                                                "
                                                :name="children.id"
                                                :id="children.id"
                                                v-model="children.value_type"
                                                class="form-control"
                                            >
                                                <option
                                                    v-for="option in getDropdownSelectedOptions(
                                                        children,
                                                        'value_type'
                                                    )"
                                                    :key="option.value"
                                                    :value="option.value"
                                                >
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                            <span
                                                v-else
                                                type="text"
                                                :name="children.id"
                                                >{{
                                                    getSingleOptionLabel(
                                                        children.options
                                                            .options,
                                                        children.value_type
                                                    )
                                                }}</span
                                            >
                                        </div>

                                        <div class="col-2 pr-0 d-flex">
                                            <select
                                                v-if="
                                                    children.options.options2 &&
                                                    Object.keys(
                                                        children.options
                                                            .options2
                                                    ).length > 1
                                                "
                                                :name="children.id"
                                                :id="children.id"
                                                v-model="children.value2"
                                                class="form-control"
                                            >
                                                <option
                                                    v-for="option2 in getSelectOptionsValue2(
                                                        children
                                                    )"
                                                    :key="option2.value"
                                                    :value="option2.value"
                                                >
                                                    {{ option2.label }}
                                                </option>
                                            </select>
                                            <span
                                                v-else
                                                type="text"
                                                :name="children.id"
                                                >{{
                                                    getSingleOptionLabel2(
                                                        children.options
                                                            .options2,
                                                        children.value_type
                                                    )
                                                }}</span
                                            >
                                        </div>

                                        <div class="col-4 pr-0">
                                            <input
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'custom_field_single_select_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <select
                                                :name="children.id"
                                                :id="children.id"
                                                v-model="children.value"
                                                class="form-control"
                                            >
                                                <option
                                                    v-for="option in getCustomFieldSelectOptions(
                                                        children
                                                    )"
                                                    :key="option.value"
                                                    :value="option.value"
                                                >
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="col-8 pr-0">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>

                                    <template
                                        v-else-if="
                                            getFieldType(children) ===
                                            'custom_field_multi_select_input'
                                        "
                                    >
                                        <div class="col-2 pr-0">
                                            <v-select
                                                multiple
                                                :id="children.id"
                                                :options="
                                                    getMultipleOptions(children)
                                                "
                                                :value="
                                                    normalizeCustomFieldMultipleValue(
                                                        children.value
                                                    )
                                                "
                                                @input="
                                                    newValue => {
                                                        children.value = newValue;
                                                    }
                                                "
                                                class="vs-overflow bg-white"
                                            />
                                        </div>

                                        <div class="col-8 pr-0">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                :name="children.id"
                                                v-model="children.comment"
                                            />
                                        </div>
                                    </template>
                                </template>

                                <template
                                    v-else-if="
                                        children.id === 'fm_soap_diagnoses'
                                    "
                                    class="col-12"
                                >
                                    <table class="table tableCustom">
                                        <thead>
                                            <tr class="bg-table bg-f2f2f2">
                                                <th>Name:</th>
                                                <th>Opened:</th>
                                                <th>Closed:</th>
                                                <th>Acuity:</th>
                                                <th>Notes:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colspan="5">
                                                    No records available
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </template>
                            </div>

                            <!-- subChildren Part -->
                            <div>
                                <draggable
                                    v-if="
                                        children.data &&
                                        children.id !== 'fm_soap_diagnoses'
                                    "
                                    :list="children.data"
                                    tag="div"
                                    ghost-class="sort-row-ghost"
                                    drag-class="sort-row-drag"
                                    :animation="0"
                                    handle=".handleSubChildren"
                                    @sort="itemsSorted(parent.id, children.id)"
                                >
                                    <div
                                        v-for="subChildren in children.data"
                                        :key="subChildren.id"
                                        class="form_template_subcomponent"
                                    >
                                        <div class="row mx-0 pb-1">
                                            <div
                                                class="px-0"
                                                :class="
                                                    subChildren.data.length > 0
                                                        ? 'col-12'
                                                        : 'col-2'
                                                "
                                            >
                                                <div
                                                    class="input_label handleSubChildren"
                                                >
                                                    <i
                                                        class="cursor-move cus-black-white-swatch marginTopHandle"
                                                    ></i>
                                                    <span class="font-italic">{{
                                                        subChildren.label
                                                    }}</span>
                                                </div>
                                            </div>

                                            <!-- 
                                            If subChildren.data is empty (last section), 
                                            then show required input field/dropdown/single select/multi select/textarea 
                                            -->
                                            <template
                                                v-if="
                                                    subChildren.data.length == 0
                                                "
                                            >
                                                <div
                                                    v-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) === 'textarea'
                                                    "
                                                    class="col-10 pr-0"
                                                >
                                                    <textarea
                                                        class="form-control mb-1"
                                                        :name="subChildren.id"
                                                        v-model="
                                                            subChildren.comment
                                                        "
                                                    ></textarea>
                                                </div>

                                                <div
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) === 'input'
                                                    "
                                                    class="col-10 pr-0"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        :name="subChildren.id"
                                                        v-model="
                                                            subChildren.comment
                                                        "
                                                    />
                                                </div>

                                                <div
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) === 'datepicker'
                                                    "
                                                    class="col-10 pr-0"
                                                >
                                                    <date-picker
                                                        class="form-control"
                                                        :config="dateOptions"
                                                        :id="subChildren.id"
                                                        :placeholder="
                                                            getDateFormat()
                                                        "
                                                        :value="
                                                            datePickerValue(
                                                                subChildren.comment
                                                            )
                                                        "
                                                        @dp-change="
                                                            handleDateChange
                                                        "
                                                    />
                                                </div>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) === 'value_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <input
                                                            :type="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                                    ? 'number'
                                                                    : 'text'
                                                            "
                                                            placeholder="Value"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.valueId
                                                            "
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            v-validate-numeric-on-blur="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                            "
                                                        />
                                                    </div>

                                                    <div class="col-8 pr-0">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) === 'dropwdown_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <select
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option in getDropdownSelectedOptions(
                                                                    subChildren
                                                                )"
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="col-8 pr-0">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) ===
                                                        'value_dropdown_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <input
                                                            :type="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                                    ? 'number'
                                                                    : 'text'
                                                            "
                                                            class="form-control"
                                                            :name="
                                                                subChildren.valueId
                                                            "
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            v-validate-numeric-on-blur="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                            "
                                                            placeholder="Value"
                                                        />
                                                    </div>

                                                    <div
                                                        class="col-2 pr-0 d-flex"
                                                    >
                                                        <select
                                                            v-if="
                                                                subChildren
                                                                    .options
                                                                    .options &&
                                                                Object.keys(
                                                                    subChildren
                                                                        .options
                                                                        .options
                                                                ).length > 1
                                                            "
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value_type
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option in mapSelectOptions(
                                                                    subChildren
                                                                        .options
                                                                        .options
                                                                )"
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </select>
                                                        <span
                                                            v-else
                                                            type="text"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            >{{
                                                                getSingleOptionLabel(
                                                                    subChildren
                                                                        .options
                                                                        .options,
                                                                    subChildren.value_type
                                                                )
                                                            }}</span
                                                        >
                                                    </div>

                                                    <div class="col-6 pr-0">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) ===
                                                        'value_dropdown_input2'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <input
                                                            :type="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                                    ? 'number'
                                                                    : 'text'
                                                            "
                                                            class="form-control"
                                                            :name="
                                                                subChildren.valueId
                                                            "
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            v-validate-numeric-on-blur="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                            "
                                                            placeholder="Value"
                                                        />
                                                    </div>

                                                    <div
                                                        class="col-2 pr-0 d-flex"
                                                    >
                                                        <select
                                                            v-if="
                                                                subChildren
                                                                    .options
                                                                    .options2 &&
                                                                Object.keys(
                                                                    subChildren
                                                                        .options
                                                                        .options2
                                                                ).length > 1
                                                            "
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value2
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option in getSelectOptionsValue2(
                                                                    subChildren
                                                                )"
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </select>
                                                        <span
                                                            v-else
                                                            type="text"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            >{{
                                                                getSingleOptionLabel(
                                                                    subChildren
                                                                        .options
                                                                        .options2,
                                                                    subChildren.value2
                                                                )
                                                            }}</span
                                                        >
                                                    </div>

                                                    <div class="col-6 pr-0">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) ===
                                                        'value_dropdown_dropdown_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <input
                                                            :type="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                                    ? 'number'
                                                                    : 'text'
                                                            "
                                                            class="form-control"
                                                            :name="
                                                                subChildren.valueId
                                                            "
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            v-validate-numeric-on-blur="
                                                                subChildren
                                                                    .options
                                                                    .isNumber
                                                            "
                                                            placeholder="Value"
                                                        />
                                                    </div>

                                                    <div
                                                        class="col-2 pr-0 d-flex"
                                                    >
                                                        <select
                                                            v-if="
                                                                subChildren
                                                                    .options
                                                                    .options &&
                                                                Object.keys(
                                                                    subChildren
                                                                        .options
                                                                        .options
                                                                ).length > 1
                                                            "
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value_type
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option in mapSelectOptions(
                                                                    subChildren
                                                                        .options
                                                                        .options
                                                                )"
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </select>
                                                        <span
                                                            v-else
                                                            type="text"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            >{{
                                                                getSingleOptionLabel(
                                                                    subChildren
                                                                        .options
                                                                        .options,
                                                                    subChildren.value_type
                                                                )
                                                            }}</span
                                                        >
                                                    </div>

                                                    <div
                                                        class="col-2 pr-0 d-flex"
                                                    >
                                                        <select
                                                            v-if="
                                                                subChildren
                                                                    .options
                                                                    .options &&
                                                                Object.keys(
                                                                    subChildren
                                                                        .options
                                                                        .options2
                                                                ).length > 1
                                                            "
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value2
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option2 in getSelectOptionsValue2(
                                                                    subChildren
                                                                )"
                                                                :key="
                                                                    option2.value
                                                                "
                                                                :value="
                                                                    option2.value
                                                                "
                                                            >
                                                                {{
                                                                    option2.label
                                                                }}
                                                            </option>
                                                        </select>
                                                        <span
                                                            v-else
                                                            type="text"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            >{{
                                                                getSingleOptionLabel2(
                                                                    subChildren
                                                                        .options
                                                                        .options2,
                                                                    subChildren.value_type
                                                                )
                                                            }}</span
                                                        >
                                                    </div>

                                                    <div class="col-4 pr-0">
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) ===
                                                        'custom_field_single_select_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <select
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            :id="subChildren.id"
                                                            v-model="
                                                                subChildren.value
                                                            "
                                                            class="form-control"
                                                        >
                                                            <option
                                                                v-for="option in getCustomFieldSelectOptions(
                                                                    subChildren
                                                                )"
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="col-8 pr-0">
                                                        <textarea
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>

                                                <template
                                                    v-else-if="
                                                        getFieldType(
                                                            subChildren
                                                        ) ===
                                                        'custom_field_multi_select_input'
                                                    "
                                                >
                                                    <div class="col-2 pr-0">
                                                        <v-select
                                                            multiple
                                                            :id="subChildren.id"
                                                            :options="
                                                                getMultipleOptions(
                                                                    subChildren
                                                                )
                                                            "
                                                            :value="
                                                                normalizeCustomFieldMultipleValue(
                                                                    subChildren.value
                                                                )
                                                            "
                                                            @input="
                                                                newValue => {
                                                                    subChildren.value = newValue;
                                                                }
                                                            "
                                                            class="vs-overflow bg-white"
                                                        />
                                                    </div>

                                                    <div class="col-8 pr-0">
                                                        <textarea
                                                            type="text"
                                                            class="form-control"
                                                            :name="
                                                                subChildren.id
                                                            "
                                                            v-model="
                                                                subChildren.comment
                                                            "
                                                        />
                                                    </div>
                                                </template>
                                            </template>
                                        </div>

                                        <!-- subSubChildren Part -->
                                        <div>
                                            <draggable
                                                v-if="subChildren.data"
                                                :list="subChildren.data"
                                                tag="div"
                                                ghost-class="sort-row-ghost"
                                                drag-class="sort-row-drag"
                                                :animation="0"
                                                handle=".handleSubSubChildren"
                                                @sort="
                                                    itemsSorted(
                                                        parent.id,
                                                        children.id,
                                                        subChildren.id
                                                    )
                                                "
                                            >
                                                <div
                                                    v-for="subSubChildren in subChildren.data"
                                                    :key="subSubChildren.id"
                                                    class="form_template_sub_subcomponent"
                                                >
                                                    <div class="row mx-0 pb-1">
                                                        <div
                                                            class="px-0"
                                                            :class="
                                                                subSubChildren
                                                                    .data
                                                                    .length > 0
                                                                    ? 'col-12'
                                                                    : 'col-2'
                                                            "
                                                        >
                                                            <div
                                                                class="input_label handleSubSubChildren"
                                                            >
                                                                <i
                                                                    class="cursor-move cus-black-white-swatch marginTopHandle"
                                                                ></i>
                                                                <span
                                                                    class="font-italic"
                                                                    >{{
                                                                        subSubChildren.label
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>

                                                        <!-- 
                                                        If subSubChildren.data is empty (last section), 
                                                        then show required input field/dropdown/single select/multi select/textarea 
                                                        -->
                                                        <template
                                                            v-if="
                                                                subSubChildren
                                                                    .data
                                                                    .length == 0
                                                            "
                                                        >
                                                            <div
                                                                v-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'textarea'
                                                                "
                                                                class="col-10 pr-0"
                                                            >
                                                                <textarea
                                                                    class="form-control mb-1"
                                                                    :name="
                                                                        subSubChildren.id
                                                                    "
                                                                    v-model="
                                                                        subSubChildren.comment
                                                                    "
                                                                ></textarea>
                                                            </div>

                                                            <div
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'input'
                                                                "
                                                                class="col-10 pr-0"
                                                            >
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    :name="
                                                                        subSubChildren.id
                                                                    "
                                                                    v-model="
                                                                        subSubChildren.comment
                                                                    "
                                                                />
                                                            </div>

                                                            <template
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'value_input'
                                                                "
                                                            >
                                                                <div
                                                                    class="col-2 pr-0"
                                                                >
                                                                    <input
                                                                        :type="
                                                                            subSubChildren
                                                                                .options
                                                                                .isNumber
                                                                                ? 'number'
                                                                                : 'text'
                                                                        "
                                                                        placeholder="Value"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.valueId
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.value
                                                                        "
                                                                        v-validate-numeric-on-blur="
                                                                            subSubChildren
                                                                                .options
                                                                                .isNumber
                                                                        "
                                                                    />
                                                                </div>

                                                                <div
                                                                    class="col-8 pr-0"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.comment
                                                                        "
                                                                    />
                                                                </div>
                                                            </template>

                                                            <template
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'dropwdown_input'
                                                                "
                                                            >
                                                                <div
                                                                    class="col-2 pr-0"
                                                                >
                                                                    <select
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        :id="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.value
                                                                        "
                                                                        class="form-control"
                                                                    >
                                                                        <option
                                                                            v-for="option in getDropdownSelectedOptions(
                                                                                subSubChildren
                                                                            )"
                                                                            :key="
                                                                                option.value
                                                                            "
                                                                            :value="
                                                                                option.value
                                                                            "
                                                                        >
                                                                            {{
                                                                                option.label
                                                                            }}
                                                                        </option>
                                                                    </select>
                                                                </div>

                                                                <div
                                                                    class="col-8 pr-0"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.comment
                                                                        "
                                                                    />
                                                                </div>
                                                            </template>

                                                            <template
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'value_dropdown_input'
                                                                "
                                                            >
                                                                <div
                                                                    class="col-2 pr-0"
                                                                >
                                                                    <input
                                                                        :type="
                                                                            subSubChildren
                                                                                .options
                                                                                .isNumber
                                                                                ? 'number'
                                                                                : 'text'
                                                                        "
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.valueId
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.value
                                                                        "
                                                                        v-validate-numeric-on-blur="
                                                                            subSubChildren
                                                                                .options
                                                                                .isNumber
                                                                        "
                                                                        placeholder="Value"
                                                                    />
                                                                </div>

                                                                <div
                                                                    class="col-2 pr-0 d-flex"
                                                                >
                                                                    <select
                                                                        v-if="
                                                                            subSubChildren
                                                                                .options
                                                                                .options &&
                                                                            Object.keys(
                                                                                subSubChildren
                                                                                    .options
                                                                                    .options
                                                                            )
                                                                                .length >
                                                                                1
                                                                        "
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        :id="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.value_type
                                                                        "
                                                                        class="form-control"
                                                                    >
                                                                        <option
                                                                            v-for="option in mapSelectOptions(
                                                                                subSubChildren
                                                                                    .options
                                                                                    .options
                                                                            )"
                                                                            :key="
                                                                                option.value
                                                                            "
                                                                            :value="
                                                                                option.value
                                                                            "
                                                                        >
                                                                            {{
                                                                                option.label
                                                                            }}
                                                                        </option>
                                                                    </select>
                                                                    <span
                                                                        v-else
                                                                        type="text"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        >{{
                                                                            getSingleOptionLabel(
                                                                                subSubChildren
                                                                                    .options
                                                                                    .options,
                                                                                subSubChildren.value_type
                                                                            )
                                                                        }}</span
                                                                    >
                                                                </div>

                                                                <div
                                                                    class="col-6 pr-0"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.comment
                                                                        "
                                                                    />
                                                                </div>
                                                            </template>

                                                            <template
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'custom_field_single_select_input'
                                                                "
                                                            >
                                                                <div
                                                                    class="col-2 pr-0"
                                                                >
                                                                    <select
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        :id="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.value
                                                                        "
                                                                        class="form-control"
                                                                    >
                                                                        <option
                                                                            v-for="option in getCustomFieldSelectOptions(
                                                                                subSubChildren
                                                                            )"
                                                                            :key="
                                                                                option.value
                                                                            "
                                                                            :value="
                                                                                option.value
                                                                            "
                                                                        >
                                                                            {{
                                                                                option.label
                                                                            }}
                                                                        </option>
                                                                    </select>
                                                                </div>

                                                                <div
                                                                    class="col-8 pr-0"
                                                                >
                                                                    <textarea
                                                                        type="text"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.comment
                                                                        "
                                                                    />
                                                                </div>
                                                            </template>

                                                            <template
                                                                v-else-if="
                                                                    getFieldType(
                                                                        subSubChildren
                                                                    ) ===
                                                                    'custom_field_multi_select_input'
                                                                "
                                                            >
                                                                <div
                                                                    class="col-2 pr-0"
                                                                >
                                                                    <v-select
                                                                        multiple
                                                                        :id="
                                                                            subSubChildren.id
                                                                        "
                                                                        :options="
                                                                            getMultipleOptions(
                                                                                subSubChildren
                                                                            )
                                                                        "
                                                                        :value="
                                                                            normalizeCustomFieldMultipleValue(
                                                                                subSubChildren.value
                                                                            )
                                                                        "
                                                                        @input="
                                                                            newValue => {
                                                                                subSubChildren.value = newValue;
                                                                            }
                                                                        "
                                                                        class="vs-overflow bg-white"
                                                                    />
                                                                </div>

                                                                <div
                                                                    class="col-8 pr-0"
                                                                >
                                                                    <textarea
                                                                        type="text"
                                                                        class="form-control"
                                                                        :name="
                                                                            subSubChildren.id
                                                                        "
                                                                        v-model="
                                                                            subSubChildren.comment
                                                                        "
                                                                    />
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>
        </draggable>
    </div>
</template>
<script>
import vSelect from "vue-select";
import {
    map,
    get,
    cloneDeep,
    difference,
    forEach,
    set,
    isNull,
    find,
    isEmpty,
    isObject,
    uniqBy,
    isNil,
    trim
} from "lodash";
import TemplateSoapServices from "@/services/template/template-soap";

export default {
    components: {
        vSelect,
        Draggable: () => import("vuedraggable")
    },
    props: {
        selectedSection: { type: Array, default: () => [] },
        medicalNoteContentAll: { type: Array, default: () => [] },
        templateId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            medicalNoteContent: [],
            isRowDragging: false,
            dateOptions: {
                format: "DD/MM/YYYY",
                timeZone: null,
                useCurrent: false
            },
            selectedValues: null,
            selectedDate: null,
            formErrors: []
        };
    },
    created() {
        this.dateOptions.timeZone = this._timeZone;
        this.dateOptions.format = this.getDateFormat();
    },
    mounted() {
        this.filterMedicalNoteContent();
    },
    directives: {
        validateNumericOnBlur: {
            // Bind the validation to the input field
            bind(el, binding, vnode) {
                // Skip if directive is false
                if (!binding.value) {
                    return;
                }

                // The input must has name property
                const inputName = el.getAttribute("name");
                if (!inputName) return;

                const validateValue = async () => {
                    try {
                        const value = el.value;
                        const rulesRegex = /^\d*(\.\d{1,3})?$/; // from apps/assets/js/validator.js
                        const valid = isEmpty(value) || rulesRegex.test(value);
                        if (valid) {
                            vnode.context.removeErrors(inputName);
                        } else {
                            vnode.context.pushErrors(inputName);
                        }
                        el.classList.toggle("border-danger", !valid);
                    } catch (error) {
                        console.error("Validation error:", error);
                    }
                };

                el._validateValue = validateValue;
                el.addEventListener("blur", validateValue);
            },
            // Unbind the validation when the input destroyed
            unbind(el) {
                // Remove the event listener to prevent memory leaks
                if (el._validateValue) {
                    el.removeEventListener("blur", el._validateValue);
                    delete el._validateValue;
                }
            }
        }
    },
    computed: {},
    watch: {
        formErrors(value) {
            this.$emit("update-is-error", value?.length > 0);
        }
    },
    methods: {
        pushErrors(key) {
            if (this.formErrors.indexOf(key) === -1) {
                this.formErrors.push(key);
            }
        },
        removeErrors(key) {
            this.formErrors = this.formErrors.filter(err => err !== key);
        },
        normalizeCustomFieldMultipleValue(value) {
            // To convert the value to array
            return Array.isArray(value) ? value : value ? [value] : [];
        },
        filterMedicalNoteContent() {
            if (
                !this.selectedSection.length ||
                !this.medicalNoteContentAll.length
            ) {
                this.medicalNoteContent = [];
                return;
            }

            const selectedIds = new Set(
                this.selectedSection.map(item => item.id)
            );

            const filterData = data =>
                data.filter(item => {
                    if (selectedIds.has(item.id)) {
                        item.data = filterData(item.data || []);
                        return true;
                    }
                    return false;
                });

            this.medicalNoteContent = filterData(
                cloneDeep(this.medicalNoteContentAll)
            );
        },
        getSingleOptionLabel(options, selectedValue) {
            if (!options || typeof options !== "object") return "";
            return options[selectedValue] || "";
        },
        /**
         *
         * @param options array objects / array list
         * @param isRemoveEmptyValue Boolean true when custom field with multiple selection
         */
        mapSelectOptions(options, isRemoveEmptyValue = false) {
            const list = uniqBy(
                map(options, (opt, index) => {
                    let value = opt;
                    let label = opt;
                    if (isObject(opt)) {
                        value = Object.keys(opt)[0];
                        label = Object.values(opt)[0];
                        if (
                            isRemoveEmptyValue &&
                            (isNil(value) ||
                                isNil(label) ||
                                trim(value) === "" ||
                                trim(label) === "")
                        ) {
                            return null; // this is set to null to be filtered out later using filter(Boolean), but only when the value is null, "", or undefined
                        }
                    } else if (Array.isArray(opt) && opt.length == 1) {
                        // Behaviour of PHP to send 0 as array when converting an array of object to array
                        value = opt[0];
                        label = opt[0];
                    } else {
                        // Besides custom field, the options will return in array, and the key will use index
                        value = index;
                    }

                    const decodedValue = this.decodeHtmlEntities(value);
                    const decodedLabel = this.decodeHtmlEntities(label);

                    return {
                        value: decodedValue,
                        label: decodedLabel
                    };
                }),
                "value"
            );

            if (isRemoveEmptyValue) {
                return list.filter(Boolean);
            }
            return list;
        },
        getDropdownSelectedOptions(data, property = "value") {
            if (!data) {
                return [];
            }
            const mappedOptions = this.mapSelectOptions(data.options.options);
            if (mappedOptions.length > 0) {
                if (data[property] === "") {
                    data[property] = data.options.defaultValue;
                }

                const isDefaultValueInOptions = find(mappedOptions, {
                    value: data[property]
                });

                if (isDefaultValueInOptions === undefined) {
                    data[property] = mappedOptions[0].value;
                }
            }
            return mappedOptions;
        },
        getSelectOptionsValue2(data) {
            if (!data) return [];
            const mappedOptions = this.mapSelectOptions(data.options.options2);

            if (data.value2 === "" && mappedOptions.length > 0) {
                data.value2 = data.options.defaultValue2;
            }

            return mappedOptions;
        },
        // single select custom field
        getCustomFieldSelectOptions(data) {
            if (!data) {
                return [];
            }
            const mappedOptions = this.mapSelectOptions(data.options.options);
            // If no value is selected, modify the children/data object to select first option
            if (!isEmpty(data.value) && Array.isArray(data.value)) {
                data.value = data.value[0];
            }

            if (isEmpty(data.value)) {
                data.value = !isEmpty(data.options.defaultValue)
                    ? data.options.defaultValue
                    : mappedOptions.length > 0
                    ? mappedOptions[0].value
                    : data.value;
            }

            return mappedOptions;
        },
        getSingleOptionLabel2(options, selectedValue = null) {
            if (!options || typeof options !== "object")
                return selectedValue ? "" : [];

            if (selectedValue !== null) {
                return get(options, selectedValue, "");
            }

            return map(options, (label, value) => ({ value, label }));
        },
        datePickerValue(date) {
            return date ? new Date(date * 1000) : null;
        },
        updateDatePickerValue(date, subChildren) {
            subChildren.comment = date
                ? Math.floor(new Date(date).getTime() / 1000)
                : null;
        },
        getMultipleOptions(data) {
            const allOptions = this.mapSelectOptions(
                data.options.options,
                true
            );
            return difference(
                allOptions.map(item => item.value),
                data.value
            );
        },
        handleDateChange(selectedDate) {
            if (selectedDate) {
                const fieldId = selectedDate.target.id;

                const timestamp = selectedDate.date
                    ? Math.floor(selectedDate.date.unix())
                    : null;

                forEach(this.medicalNoteContent, parent => {
                    forEach(parent.data, child => {
                        forEach(child.data, subChild => {
                            // Check if the item has the matching fieldId and update its comment
                            if (subChild.id === fieldId) {
                                set(subChild, "comment", timestamp);
                            }
                        });
                    });
                });
            }
        },
        getFieldType(data) {
            const options = data.options || {};
            let fieldType = "";
            const textareaCondition =
                (Array.isArray(options) && options.length === 0) ||
                (options.hasComment && !options.isCategoryLabel) ||
                (data.id &&
                    data.label === "Notes" &&
                    (data.id.includes("_comment") ||
                        data.id.includes("_notes")) &&
                    Object.keys(options).length === 0);

            if (textareaCondition) {
                fieldType = "textarea";
                data.fieldType = fieldType;
                return fieldType;
            }

            const inputFieldCondition =
                !options.hasComment &&
                !options.isCategoryLabel &&
                !options.isNumber &&
                (options.elementValue === "" ||
                    options.elementValue === null) &&
                (!Array.isArray(options.options) ||
                    options.options.length === 0) &&
                (!Array.isArray(options.options2) ||
                    options.options2.length === 0);

            if (inputFieldCondition) {
                fieldType = "input";
                data.fieldType = fieldType;
                return fieldType;
            }

            const valueInputFieldCondition =
                !options.hasComment &&
                !options.isCategoryLabel &&
                options.defaultValue !== null &&
                options.isNumber !== null &&
                options.isDatePicker === undefined &&
                options.elementValue === "value" &&
                Array.isArray(options.options) &&
                options.options.length == 0 &&
                data.value !== null &&
                !data.value_type;

            if (valueInputFieldCondition) {
                fieldType = "value_input";
                data.valueId = `${data.id}-value`;
                data.fieldType = fieldType;
                return fieldType;
            }

            const inputDatePicker =
                !options.hasComment &&
                !options.isCategoryLabel &&
                options.isDatePicker;

            if (inputDatePicker) {
                fieldType = "datepicker";
                data.fieldType = fieldType;
                return fieldType;
            }

            const selectCondition =
                (Array.isArray(options.options) &&
                    options.options.length > 0) ||
                (Array.isArray(options.options2) &&
                    options.options2.length > 0) ||
                options.options !== null ||
                options.options2 !== null;

            if (selectCondition) {
                const dropwdownInputCondition =
                    !options.hasComment &&
                    !options.isCategoryLabel &&
                    !options.isNumber &&
                    options.elementValue &&
                    options.defaultValue !== null &&
                    data.value !== null &&
                    !data.value_type;
                if (dropwdownInputCondition) {
                    fieldType = "dropwdown_input";
                    data.valueId = `${data.id}-value`;
                    data.fieldType = fieldType;
                    return fieldType;
                }

                const valueDropdownInput =
                    !options.hasComment &&
                    !options.isCategoryLabel &&
                    (options.options2 == null ||
                        options.options2.length == 0) &&
                    options.elementValue &&
                    options.defaultValue !== null &&
                    data.value_type !== null &&
                    data.value_type !== undefined;
                if (valueDropdownInput) {
                    fieldType = "value_dropdown_input";
                    data.valueId = `${data.id}-value`;
                    data.valueTypeId = `${data.id}-value_type`;
                    data.fieldType = fieldType;
                    return fieldType;
                }

                const valueDropdownInput2 =
                    !options.hasComment &&
                    !options.isCategoryLabel &&
                    options.options2 &&
                    typeof options.options2 === "object" &&
                    Object.keys(options.options2).length > 0 &&
                    options.elementValue &&
                    options.defaultValue === undefined &&
                    options.defaultValue2 !== null &&
                    data.value2 !== null &&
                    data.value2 !== undefined;
                if (valueDropdownInput2) {
                    // eg: Diagnostic > Urinalysis > pH
                    fieldType = "value_dropdown_input2";
                    data.valueId = `${data.id}-value`;
                    data.value2Id = `${data.id}-value2`;
                    data.fieldType = fieldType;
                    return fieldType;
                }

                const valueDropdownDropdownInput =
                    !options.hasComment &&
                    !options.isCategoryLabel &&
                    options.options2 &&
                    options.defaultValue !== null &&
                    options.defaultValue2 !== null &&
                    data.value_type !== null &&
                    data.value_type !== undefined;
                if (valueDropdownDropdownInput) {
                    fieldType = "value_dropdown_dropdown_input";
                    data.fieldType = fieldType;
                    data.valueId = `${data.id}-value`;
                    data.value2Id = `${data.id}-value2`;
                    data.valueTypeId = `${data.id}-value_type`;
                    return fieldType;
                }

                const isCustomField =
                    !options.hasComment &&
                    !options.isCategoryLabel &&
                    options.defaultValue !== null &&
                    data.value !== null;

                if (isCustomField) {
                    const customFieldWithoutDropdown =
                        Array.isArray(options.options) &&
                        options.options.length === 0;

                    const customFieldSingleSelect = !options.isMultiple;
                    const customFieldMultiSelect = options.isMultiple;

                    if (customFieldWithoutDropdown) {
                        fieldType = "textarea";
                    } else if (customFieldSingleSelect) {
                        fieldType = "custom_field_single_select_input";
                        data.valueId = `${data.id}-value`;
                    } else if (customFieldMultiSelect) {
                        fieldType = "custom_field_multi_select_input";
                        data.valueId = `${data.id}-value`;
                    }

                    data.fieldType = fieldType;
                    return fieldType;
                }
            }
        },
        async itemsSorted(
            parentId = null,
            childrenId = null,
            subChildrenId = null
        ) {
            let params = null;
            const errorMessage =
                "Error: Unable to sort the medical note content";
            try {
                const parentSortedObject = this.findParentObject(
                    parentId,
                    childrenId,
                    subChildrenId
                );
                if (isNull(parentId)) {
                    // Sorting in parent level
                    params = this.generateParams("category_reorder", {
                        filteredMedicalNoteContent: this.medicalNoteContent,
                        unFilteredMedicalNoteContent: this.medicalNoteContentAll
                    });
                } else if (isNull(parentSortedObject)) {
                    throw Error(errorMessage);
                } else {
                    let typeOrder = "";
                    let parentSortedId = null;

                    if (isNull(childrenId)) {
                        // Sorting in children level
                        typeOrder = "component_reorder";
                        parentSortedId = parentId;
                    } else {
                        if (isNull(subChildrenId)) {
                            // Sorting in sub children level
                            typeOrder = "subcomponent_reorder";
                            parentSortedId = childrenId;
                        } else {
                            // Sorting in sub sub children level
                            typeOrder = "sub_subcomponent_reorder";
                            parentSortedId = subChildrenId;
                        }
                    }

                    params = this.generateParams(
                        typeOrder,
                        parentSortedObject,
                        parentSortedId
                    );
                }
                const res = await TemplateSoapServices.reorderMedicalNoteTemplate(
                    this.templateId,
                    params
                );

                if (res) {
                    this._message("Changes saved");
                } else {
                    throw new Error(errorMessage);
                }
            } catch (e) {
                console.error(e);
                this._message(errorMessage);
            }
        },
        findParentObject(parentId, childrenId, subChildrenId) {
            // Find the parent object using the ids
            const ids = [parentId, childrenId, subChildrenId].filter(
                id => id !== null
            );

            if (ids.length != 0) {
                const findNestedObject = (data, ids) => {
                    let current = data;

                    for (const id of ids) {
                        if (!Array.isArray(current)) {
                            return null;
                        }
                        const found = find(current, { id });
                        if (!found) {
                            return null;
                        }
                        current = found.data;
                    }

                    return current;
                };

                return {
                    filteredMedicalNoteContent: findNestedObject(
                        this.medicalNoteContent,
                        ids
                    ),
                    unFilteredMedicalNoteContent: findNestedObject(
                        this.medicalNoteContentAll,
                        ids
                    )
                };
            }
            return null;
        },
        generateParams(
            typeOrder,
            { filteredMedicalNoteContent, unFilteredMedicalNoteContent },
            parentId = null
        ) {
            // As in CI, if original data has 6 components, then selected only 3 components, when sorted, CI always send all 6 with the updated sorting
            const original = unFilteredMedicalNoteContent.map(obj => obj.id);
            const newOrder = filteredMedicalNoteContent.map(obj => obj.id);
            let savedSet = new Set(newOrder);
            let unselectedComponent = difference(original, newOrder);

            let sortedArray = [];
            let savedIndex = 0,
                remainingIndex = 0;

            forEach(original, num => {
                sortedArray.push(
                    savedSet.has(num)
                        ? newOrder[savedIndex++]
                        : unselectedComponent[remainingIndex++]
                );
            });

            // Sort unFilteredMedicalNoteContent based on sortedArray order
            // This will update the medicalNoteContentAll as the object is reactive
            unFilteredMedicalNoteContent.sort(
                (a, b) => sortedArray.indexOf(a.id) - sortedArray.indexOf(b.id)
            );

            return {
                type_order: typeOrder,
                data: sortedArray,
                parent: parentId
            };
        }
    }
};
</script>
<style scoped>
.parent_label {
    font-weight: bold;
    font-size: 120%;
}

.input_label {
    cursor: pointer;
    padding-bottom: 0.5rem;
}

.marginTopHandle {
    margin-top: 1px !important;
}

.form_template_category {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_component {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_subcomponent {
    background: #fff;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_sub_subcomponent {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.tableCustom {
    margin-top: 10px;
    border: 1px solid #ccc;
}
</style>

<style>
.vs-overflow .vs__selected-options {
    overflow: auto;

    /* Firefox */
    scrollbar-width: none;
}

/* chrome, edge, safari */
.vs-overflow .vs__selected-options::-webkit-scrollbar {
    width: 4px !important;
    height: 4px !important;
}

.vs__dropdown-menu {
    width: fit-content;
}
</style>
